<template>
    <div class="reg-temp-content-area p-3 main-content-height">
        <div class="superadmin-dashboard-area edit-area">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="registered-product-item w-half">
                            <router-link
                                :to="{name: $route.query.redirect ? $route.query.redirect : 'DistributorCustomers'}"
                                class="mb-3 inline-block"
                                ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                            >
                            <h3 class="mb-4">Add New User</h3>
                            <ul>
                                <li>
                                    <span class="semibold mb-2">Select the type of user you want to create</span>
                                    <custom-check-box
                                        name="role"
                                        :form="form"
                                        :options="[
                                            {name: 'Reseller', value: 'reseller'},
                                            {name: 'Customer', value: 'customer'}
                                        ]"
                                    />
                                </li>

                                <li>
                                    <span class="semibold">First Name:</span>
                                    <span><input type="text" v-model="form.fname" name="fname" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">Last name:</span>
                                    <span><input type="text" v-model="form.lname" name="lname" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">Email:</span>
                                    <span><input type="text" v-model="form.email" name="email" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">Company:</span>
                                    <span><input type="text" v-model="form.company" name="company" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">Address:</span>
                                    <span class="notice">( Please select the address from suggestion )</span>
                                    <span>
                                        <gmap-autocomplete
                                            id="customer_edit_address"
                                            autocomplete="nope"
                                            class="form-control"
                                            large
                                            name="address"
                                            placeholder="Your address..."
                                            :select-first-on-enter="true"
                                            :componentRestrictions="{country: ['ZA']}"
                                            @place_changed="setPlace"
                                            @keyup="resetPlace"
                                        >
                                        </gmap-autocomplete>
                                    </span>
                                    <div class="address-info-wrap" v-if="form.address && form.addressDetail && form.addressDetail.province">
                                        <p class="address-info"><span>Province:</span> {{ form.addressDetail.province }}</p>
                                        <p class="address-info"><span>City:</span> {{ form.addressDetail.city }}</p>
                                        <p class="address-info"><span>Suburb:</span> {{ form.addressDetail.suburb }}</p>
                                        <p class="address-info"><span>Postcode:</span> {{ form.addressDetail.postcode }}</p>
                                    </div>
                                </li>

                                <li>
                                    <span class="semibold">Complex/Building + Unit:</span>
                                    <span
                                        ><input type="text" v-model="form.complex_building_unit" name="complex_building_unit" class="form-control"
                                    /></span>
                                </li>

                                <li>
                                    <span class="semibold">Mobile:</span>
                                    <span><input type="text" v-model="form.mobile" name="mobile" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">Password:</span>
                                    <span><input type="password" v-model="form.password" name="mobile" class="form-control" /></span>
                                </li>

                                <template v-if="form.role == 'reseller'">
                                    <ul class="mb-3 mt-3">
                                        <li class="border-b-1">
                                            <span class="semibold mb-2">Has website?</span>
                                            <div class="form-check form-check-inline">
                                                <input
                                                    v-model.number="form.has_website"
                                                    class="form-check-input"
                                                    type="radio"
                                                    name="haveWebsite"
                                                    id="website_yes"
                                                    value="1"
                                                />
                                                <label class="form-check-label" for="website_yes">Yes</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input
                                                    v-model.number="form.has_website"
                                                    class="form-check-input"
                                                    type="radio"
                                                    name="haveWebsite"
                                                    id="website_no"
                                                    value="0"
                                                />
                                                <label class="form-check-label" for="website_no">No</label>
                                            </div>
                                            <ul class="mt-3">
                                                <li v-if="form.has_website == 1" class="website-holder mb-0">
                                                    <span class="website-prefix dark">https://</span>
                                                    <input type="text" v-model="form.website" placeholder="eg: example.com" class="form-control" />
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>

                                    <li>
                                        <span class="semibold mb-2">Reseller Type:</span>
                                        <select v-model="form.reseller_type" class="baseline-input">
                                            <option value="">--Select reseller type--</option>
                                            <option :value="resellerType.value" v-bind:key="resellerType.value" v-for="resellerType in resellerTypes">
                                                {{ resellerType.label }}
                                            </option>
                                        </select>
                                    </li>

                                    <li>
                                        <span class="semibold mb-2">Select Region:</span>
                                        <select v-model="form.region" class="baseline-input">
                                            <option value="">--Select region--</option>
                                            <option :value="region" v-bind:key="region" v-for="region in regions">{{ region }}</option>
                                        </select>
                                    </li>
                                </template>

                                <li>
                                    <button class="btn btn-primary mt-3 px-5" @click.prevent="addDistributorCustomer()">+ ADD</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Helpers from '@/helpers/index';

export default {
    name: 'distributorCustomerAdd',
    data() {
        return {
            roles: ['reseller', 'customer'],
            form: {
                fname: '',
                lname: '',
                email: '',
                company: '',
                address: '',
                website: '',
                has_website: 0,
                complex_building_unit: '',
                addressDetail: {
                    province: '',
                    city: '',
                    suburb: '',
                    postcode: '',
                    lat: '',
                    lng: ''
                },
                mobile: '',
                role: 'reseller',
                password: '',
                region: '',
                reseller_type: ''
            }
        };
    },
    watch: {
        'form.has_website'() {
            if (!this.form.has_website) {
                this.form.website = '';
            }
        }
    },
    computed: {
        regions() {
            return Env.regions;
        },
        resellerTypes() {
            return Env.resellerTypes;
        }
    },
    methods: {
        /**
         * autocomplete set
         */
        setPlace: async function (addressData) {
            if (_.isEmpty(addressData)) {
                return;
            }
            this.form.address = addressData.formatted_address;
            let province = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1');
            let city = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_2');
            let suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_1');
            if (!suburb) {
                suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_2');
            }
            let postcode = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'postal_code');
            let {lat, lng} = Helpers.getLatLngFromGoogleAutoComplete(addressData);
            this.form.addressDetail = {
                province,
                city,
                suburb,
                postcode,
                lat,
                lng
            };
        },

        resetPlace: function () {
            this.form.address = '';
            this.form.addressDetail = {
                province: '',
                city: '',
                suburb: '',
                postcode: '',
                lat: '',
                lng: ''
            };
        },
        async addDistributorCustomer() {
            // there must be lat , lng
            if (!this.form.addressDetail.lat && !this.form.addressDetail.lng) {
                return this.$toasted.global.error({
                    message: 'Please select one of the address from suggestion.'
                });
            }
            this.spinner(true);
            const url = `${Env.baseUrl}/distributor/customers/create`;
            AuthApis.postApi(url, this.form)
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: 'Successfully added.'
                    });
                    this.$router.push({name: this.$route.query.redirect ? this.$route.query.redirect : 'DistributorCustomers'});
                })
                .catch((err) => {
                    this.spinner(false);
                    this.$toasted.global.error({
                        message: err.response ? (err.response.data ? err.response.data.errors[0] : 'Fail.') : 'Please try again later.'
                    });
                });
        }
    }
};
</script>
